export default __webpack_public_path__ + "f63333d3a957ae6c1f7a258d6bde5a6d.png";